import React, { useState, useEffect, useRef } from "react";
import "./PedidosPendientes.css";
import {
  getProcessingOrders,
  getOrderLines,
} from "../../services/Carrito/getOrders&Invoices";
import {
  createInvoiceFromOrder,
  validateInvoice,
} from "../../services/posInvoices";
import { setOrderAsInvoiced } from "../../services/posOrders";
import {
  createOrderShipment,
  validateShipment,
} from "../../services/Shipments/shipmentManagement";

const PedidosPendientes = ({ setPendientesCount }) => {
  const [pedidos, setPedidos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showProductos, setShowProductos] = useState(null);
  const [orderLines, setOrderLines] = useState([]);
  
  // Ref para hacer scroll hacia la tabla de productos
  const productosTableRef = useRef(null);
  
  localStorage.removeItem("carritoActual");

  // Obtener el usuario de localStorage y asignar el valor correspondiente
  const asociaName = localStorage.getItem("asociaName");
  let userValue;
  switch (asociaName) {
    case "ASEIC":
      userValue = 1;
      break;
    case "AEMTEC":
      userValue = 2;
      break;
    case "PABLO":
      userValue = 3;
      break;
    case "ANDRÉS":
      userValue = 5;
      break;
    case "AESETEC":
      userValue = 4;
      break;
    case "ADESC":
      userValue = 6;
      break;
    default:
      userValue = null;
  }
  //console.log("Usuario:", asociaName, userValue);

useEffect(() => {
  const fetchOrders = async () => {
    try {
      const orders = await getProcessingOrders(userValue.toString());
      
      // Filtrar pedidos por warehouse_id
      const filteredOrders = orders.filter(order => {
        if (order.warehouse_id === null) {
          // Si warehouse_id es null, solo mostrar a Pablo (3) o Andrés (5)
          return userValue === 3 || userValue === 5;
        }
        // Si no es null, mostrar solo los que coincidan con userValue
        return order.warehouse_id === userValue.toString();
      });

      console.log("Fetched filtered orders:", filteredOrders);
      setPedidos(filteredOrders);
      setPendientesCount(filteredOrders.length);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };
  fetchOrders();
}, [setPendientesCount, userValue]);

  const handleVer = async (id) => {
    if (showProductos === id) {
      setShowProductos(null);
      setOrderLines([]);
    } else {
      setShowProductos(id);
      try {
        const lines = await getOrderLines(id);
        setOrderLines(lines);
        
        // Hacer scroll hacia la tabla de productos después de un pequeño delay
        // para asegurar que el DOM se haya actualizado
        setTimeout(() => {
          if (productosTableRef.current) {
            productosTableRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 100);
        
      } catch (error) {
        console.error("Error fetching order lines:", error);
      }
    }
  };

  const filteredPedidos = pedidos.filter(
    (pedido) =>
      pedido.id.toString().includes(searchTerm.toLowerCase()) ||
      (pedido.nombre &&
        pedido.nombre.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handlePedidoAlistado = async () => {
    try {
      console.log("Pedido alistado:", parseInt(showProductos));

      const shipmentCreated = await createOrderShipment(parseInt(showProductos), userValue);
      if (shipmentCreated) {
        const shipmentValidated = await validateShipment(parseInt(shipmentCreated));
        if (shipmentValidated) {
          alert("Pedido alistado con éxito.");
          window.location.reload();
        } else {
          throw new Error("Error al validar el envío.");
        }
      } else {
        throw new Error("Error al crear el envío.");
      }
    } catch (error) {
      console.error("Error en el proceso de alistar pedido:", error.message);
    }
  };

  return (
    <div className="pedidos-container">
      <div className="search-container">
        <h2 className="pedidos-heading">Pedidos que faltan de Alistar</h2>
        <input
          type="text"
          placeholder="Buscar por ID o Nombre"
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <table className="pedidos-table">
        <thead>
          <tr>
            <th className="pedidos-table-header"></th>
            <th className="pedidos-table-header">ID</th>  
            <th className="pedidos-table-header">Nombre</th>
            <th className="pedidos-table-header">Fecha</th>
            <th className="pedidos-table-header">Total</th>
            <th className="pedidos-table-header">Acción </th>
          </tr>
        </thead>
        <tbody>
          {filteredPedidos.map((pedido, idx) => (
            <tr key={idx} className="pedidos-table-row">
              <td className="pedidos-table-cell">{pedido.id}</td>
              <td className="pedidos-table-cell">{pedido.nombre}</td>
              <td className="pedidos-table-cell">
                {pedido.date_creation || pedido.fecha}
              </td>
              <td className="pedidos-table-cell">
                ₡ {parseInt(pedido.total).toFixed(0)}
              </td>
              <td className="pedidos-table-cell">
                <button
                  className="pedidos-view-button"
                  onClick={() => handleVer(pedido.id)}
                >
                  Ver
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showProductos !== null && (
        <div className="productos-table-container" ref={productosTableRef}>
          <div className="productos-table">
            <h3>
              Pedido ID: {showProductos} -{" "}
              {pedidos.find((p) => p.id === showProductos)?.nombre || ""}
            </h3>
            {orderLines.length > 0 ? (
              <table className="productos-table">
                <thead>
                  <tr>
                    <th>Código artículo</th>
                    <th>Artículo</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {orderLines.map((line, idx) => {
                    const subtotal = line.qty * line.subprice;
                    return (
                      <tr key={idx}>
                        <td>{line.product_ref}</td>
                        <td>{line.product_label}</td>
                        <td>{line.qty}</td>
                        <td>{`₡${subtotal.toFixed(0)}`}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p>No hay líneas de orden para este pedido.</p>
            )}
          </div>

          {/* Botón Pedido Alistado */}
          <button
            className="pedidos-view-button"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "auto",
              marginTop: "1rem",
            }}
            onClick={handlePedidoAlistado}
          >
            Pedido Alistado
          </button>
        </div>
      )}
    </div>
  );
};

export default PedidosPendientes;